import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { ForPaintSoftwareProjectSidebar as AsyncForPaintSidebarNextGen } from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createLayout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { issueNavigatorProjectSoftwareRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorProjectSoftwareRoute.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { issueNavigatorPageEntryPoint } from './ui/index.tsx';

/**
 * Software Project Issue Navigator Route Entry
 * Handles Software projects.
 */
export const issueNavigatorProjectSoftwareRouteEntry = createEntry(
	issueNavigatorProjectSoftwareRoute,
	() => ({
		group: 'issue-navigator',
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: ProjectIssueNavigatorSkeleton,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncForPaintSidebarNextGen,
			horizontal: AsyncHorizontalNavJira,
			onlyShowHorizontalOnNav4: true,
		},
		resources: [...getCommonProjectResources()],
		layout: createLayout(softwareProjectLayoutNoOnboarding),
		bifrost: {
			bifrostGroup: 'issue-navigator',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorProjectSoftwareRouteEntry',
			},
			enabled: true,
		},
		entryPoint: () => issueNavigatorPageEntryPoint,
		supportsPreviewPanel: true,
	}),
);
